import { render } from "./Ack.vue?vue&type=template&id=3047e9ea&scoped=true&lang=pug"
import script from "./Ack.vue?vue&type=script&lang=js"
export * from "./Ack.vue?vue&type=script&lang=js"

import "./Ack.vue?vue&type=style&index=0&id=3047e9ea&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3047e9ea"]])

export default __exports__